import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "./context/AuthContext";
import { PlayerProvider } from "./context/PlayerContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Browse from "./pages/Browse";
import Genres from "./pages/Genres";
import GenreDetail from "./pages/GenreDetail";
import Search from "./pages/Search";
import Favorites from "./pages/Favorites";
import RecentlyPlayed from "./pages/RecentlyPlayed";
import { PlaylistsIndex, PlaylistDetail } from "./pages/Playlists";
import Watch from "./pages/Watch";
import { Login, Register, ForgotPassword, ResetPassword, VerifyEmail } from "./pages/Auth";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";
import Following from "./pages/Following";
import { Terms, Privacy } from "./pages/Legal";
import About from "./pages/About";
import MyVideos from "./pages/MyVideos";
import DjBooth from "./pages/DjBooth";
import DjScreen from "./pages/DjScreen";
import DjJoin from "./pages/DjJoin";
import PageSeo from "./components/PageSeo";
import { UpgradeProvider } from "./components/UpgradePrompt";
import { AgeGateProvider } from "./components/AgeGate";

function App() {
  return (
    <AuthProvider>
      <PlayerProvider>
        <BrowserRouter>
          <PageSeo />
          <UpgradeProvider>
            <AgeGateProvider>
            <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/music" element={<Navigate to="/videos" replace />} />
              <Route path="/videos" element={<Browse title="Music Videos" />} />
              <Route path="/genres" element={<Genres />} />
              <Route path="/genres/:slug" element={<GenreDetail />} />
              <Route path="/search" element={<Search />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/recent" element={<RecentlyPlayed />} />
              <Route path="/following" element={<Following />} />
              <Route path="/playlists" element={<PlaylistsIndex />} />
              <Route path="/playlists/:id" element={<PlaylistDetail />} />
              <Route path="/watch/:id" element={<Watch />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/account" element={<Account />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/about" element={<About />} />
              <Route path="/my-videos" element={<MyVideos />} />
              <Route path="/dj" element={<DjBooth />} />
              <Route path="/dj/screen" element={<DjScreen />} />
              <Route path="/dj/join/:invite" element={<DjJoin />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
            </AgeGateProvider>
          </UpgradeProvider>
        </BrowserRouter>
      </PlayerProvider>
    </AuthProvider>
  );
}

export default App;
